import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { supplierProductsQuery } from './gql';

export const useProductsGql = () => {
  const [runProductsGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(supplierProductsQuery, {
    context: {
      headers: {
        userFunctionKey: 'a684eceee76fc522773286a895bc8436'
      }
    }
  });

  return {
    runProductsGql,
    loadingProducts: loading,
    dataProducts: data?.suppliersProducts || [],
    errorProducts: error
  };
};
